<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="60%" :visible.sync="viewData.visible">

    <!-- 生产量纲 车型 汇率 零件名称 零件号 零件-单车用量 零件-装配比例 零件-供货比例 模具费支付方式 开发费支付方式 开标时间 报价截止时间 工厂编号 备注特殊要求-->
    <!-- <el-steps :active="active" finish-status="success" process-status="error">
        <el-step title="任务开始"></el-step>
        <el-step title="询价"></el-step>
        <el-step title="报价"></el-step>
        <el-step title="合同"></el-step>
        <el-step title="协议"></el-step>
        <el-step title="订单"></el-step>
        <el-step title="交货"></el-step>
        <el-step title="任务结束"></el-step>
    </el-steps> -->
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form">
        <el-tabs>
            <el-tab-pane class="tab_style" :key="1" label="基础信息">
                <div class="des_box">
                    <el-descriptions class="margin-top" :column="2" size="small" border>
                        <el-descriptions-item label="定点申请" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="technicalName" style="margin-bottom: 0">
                                {{technicalName}}
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="定点申请编码" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="technicalCode" style="margin-bottom: 0" size="small">
                                <el-button size="small" @click="techView()" type="text">{{ dataForm.technicalCode }}</el-button>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="定点申请类型" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="technicalType" style="margin-bottom: 0" size="small">
                                <span>{{ getTechnicalValue(technicalType) }}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="任务编码" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="taskCode" style="margin-bottom: 0" size="small">
                                <span>{{ dataForm.taskCode }}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="询价单编码" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="rfqCode" style="margin-bottom: 0" size="small">
                                <span>{{ dataForm.rfqCode }}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="项目名称" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="projectName" style="margin-bottom: 0" size="small">
                                <span>{{ projectName }}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购负责人" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="supplyResponsor" style="margin-bottom: 0">
                                {{dataForm.supplyResponsor}}
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="技术负责人" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="techResponsor" style="margin-bottom: 0">
                                {{ dataForm.techResponsor }}
                            </el-form-item>
                        </el-descriptions-item>

                        <el-descriptions-item label="质量负责人" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="qualityResponsor" style="margin-bottom: 0">
                                {{ dataForm.qualityResponsor }}
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购工程师" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="supplyEngineer" style="margin-bottom: 0">
                                {{ dataForm.supplyEngineer }}
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item :span="2" label="任务描述" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="remark" style="margin-bottom: 0" size="small">
                                <span>{{ dataForm.remark }}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item :span="2" label="退回理由" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="rejectReason" style="margin-bottom: 0" size="small">
                                <span>{{ dataForm.rejectReason }}</span>
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>

                </div>

            </el-tab-pane>
            <el-tab-pane class="tab_style" :key="2" label="零件清单">
                <el-row :gutter="10">
                    <el-col :span="24">
                        <!-- <span>零件清单</span>
                            <el-button
                                v-if="
                                    [
                                        USER_TYPE.MANAGER,
                                        USER_TYPE.SUPPLERMANAGER,
                                    ].includes(userInfo.typeId)
                                "
                                style="float: right"
                                size="small"
                                @click="selectAppart()"
                                class="mb15"
                                :disabled="!dataForm.id"
                                >选择零件</el-button
                            > -->
                        <el-table :data="partList" :row-style="getRowStyle"  row-key="id" size="small" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }" class="mb15">
                            <el-table-column type="index" width="50" label="序号">
                                <template slot-scope="scope">
                                    {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="partCode" header-align="center" align="left" label="零件编号">
                            </el-table-column>
                            <el-table-column prop="partName" header-align="center" align="left" label="零件名称">
                            </el-table-column>
                            <el-table-column prop="cancelFlag" width="160" header-align="center" align="left" label="取消标识">
                              <template slot-scope="scope">
                                <span>{{ scope.row.cancelFlag === 1 ? '是' : "否" }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column prop="unit" header-align="center" align="center" label="单位">
                            </el-table-column>
                            <el-table-column prop="oneCarCount" header-align="center" align="right" label="单车用量">
                            </el-table-column>
                            <!-- TODO: QA:目标价是必须的吗？ -->
                            <el-table-column prop="targetPrice" header-align="center" align="right" label="目标价格">
                            </el-table-column>
                            <el-table-column prop="supplyStatus" header-align="center" align="center" label="建议货源">
                                <template slot-scope="scope">
                                    <span>
                                        {{supplyStatusFormat(scope.row.supplyStatus)}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="targetInvestment" header-align="center" align="center" label="目标工装费">
                            </el-table-column>
                            <el-table-column prop="targetDevelopment" header-align="center" align="center" label="目标开发费">
                            </el-table-column>
                            <el-table-column prop="targetTestfee" header-align="center" align="center" label="目标试验费">
                            </el-table-column>
                        </el-table> <!-- 分页 -->
                        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" style="text-align: right" class="mb15 mt10">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane class="tab_style" :key="3" label="附件文件">
                <!-- TODO:上传下载 产看 需求文档 -->
                <FilesUpDown ref="FilesUpDown" :bizId="this.dataForm.technicalId" :bizType="FILE_BIZ_TYPE" ></FilesUpDown>
            </el-tab-pane>
        </el-tabs>
    </el-form>
    <span v-if="viewFlag === 'view'" slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewData.visible = false">
            取消
        </el-button>
    </span>

    <span v-else slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewData.visible = false">
            取消
        </el-button>
        <!-- <el-button v-if="userInfo.typeId !== USER_TYPE.SUPPLIER" size="small" type="primary" @click="dataSave()">
                保存
            </el-button> -->
        <template v-if="viewFlag !== 'view'">
            <el-button size="small" v-if="userInfo.typeId !== USER_TYPE.SUPPLIER && dataForm.taskStatus === CONST_TASK_STATUS.DISTRIBUTED" type="success" plain @click="dataConfirm()" :loading="loading">接受</el-button>
            <el-button size="small"  type="danger" plain @click="rejectView()" :loading="loading">退回</el-button>
            <!-- 已完成 -->
            <el-button v-if="isAuth('sourcing:rfq:button') && this.dataForm.taskStatus === '2' && !dataForm.rfqCode" size="small" type="success" plain @click="createRFQ()" :loading="loading">
                创建询价RFQ </el-button><!-- 询价函 -->
            <!--<el-button type="danger" size="small" v-if="this.dataForm.taskStatus === '2' && !dataForm.rfqCode && this.plmTechCount > 0" @click="deleteHandle(dataForm.id, dataForm.taskStatus)" plain :loading="loading">
                废弃
            </el-button>-->
        </template>
        <!-- <el-button v-if="
                        userInfo.typeId !== USER_TYPE.SUPPLIER &&
                        dataForm.taskStatus !== TASK_STATUS.RECIEVED
                    " size="small" type="success" @click="createOrder()"> 创建样件订单 </el-button> -->

    </span>
    <common-user-dialog ref="commonUserDialog"></common-user-dialog>
    <!-- 弹窗, 查询零件表-->
    <task-get-part ref="addOrUpdatePart"></task-get-part>
    <!-- 查看定点申请详情 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update>
    <task-reject-reason ref="taskRejectReason"></task-reject-reason>
</el-dialog>
</template>

<script>
import {
    addPurchaseTask,
    editPurchaseTask,
    editPurchaseTaskSucc,
    editPurchaseTaskFal,
    getPurchaseTaskById,
    editPurchaseTaskRfq,
    deletePurchaseTaskFei
} from "@/controller/purchaseTask";
import AddOrUpdate from "../requirement/tech-add-or-update";
import FilesUpDown from "@/views/common/file-up-down";
import {
    setLoading
} from "@/utils/index";
import {
    getTaskApparmentList,
    deleteTaskApparmentByIds,
} from "@/controller/tech";
import {
    getPlmTechnicalCountByPT
} from "@/controller/plmTech";
import moment from "moment";
import {
    DIALOG_CLOSED_TYPE,
    TASK_STATUS,
    USER_TYPE,
    SUPPLY_STATUS,
    TECHNICAL_NOTIFICATION_TYPE,
    getLabelByValue,
    getTechnicalValue
} from "@/utils/const";
import {
    mapping
} from "@/utils";
import CommonUserDialog from "@/views/common/common-user-dialog";
import TaskGetPart from "./task-part-list";
import TaskRejectReason from "@/views/common/reject-reason";
// require('@/mock/mockTask');
export default {
    data() {
        return {
            loading: false,
            FILE_BIZ_TYPE: 10,
            active: 3,
            viewFlag: "",
            viewData: {
                visible: false,
                width: "",
            },
            taskGetTechVisible: false,
            taskGetAppartVisible: false,
            addOrUpdateVisible: false,
            dataList: [],
            partList: [],
            supplierList: [],
            userInfo: "",
            USER_TYPE: USER_TYPE,
            CONST_SUPPLY_STATUS: SUPPLY_STATUS,
            CONST_TASK_STATUS: TASK_STATUS,
            getLabelByValue: getLabelByValue,
            getTechnicalValue: getTechnicalValue,
            TECHNICAL_NOTIFICATION_TYPE: TECHNICAL_NOTIFICATION_TYPE,
            projectName: '',
            technicalType: '',
            technicalName: '',
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            // 任务表里字段
            dataForm: {
                id: 0,
                // ...this.dataForm,
                projectId: "",
                projectCode: "",
                projectName: "",
                taskCode: "",
                taskName: "",
                carType: "",
                projectManagerId: "",
                projectManagerName: "",
                taskType: "",
                taskStatus: "",
                createTaskTime: "",
                times: "",
                askPriceCode: "",
                feeCode: "",
                askPriceStatus: "",
                delayTimes: "",
                rfqCreateTime: "",
                rfqFinishTime: "",
                submitor: "",
                technicalId: "",
                technicalName: "", //数据库里没有
                technicalType: '',
                submitorId: "",
                technicalCode: "",
                supplyResponsorId: "",
                supplyResponsor: "",
                techResponsorId: "",
                techResponsor: "",
                qualityResponsorId: "",
                qualityResponsor: "",
                supplyEngineerId: "",
                supplyEngineer: "",
                remark: "",
                rfqCode: "",
                rejectReason: "",
            },
            dataRule: {
                name: [{
                    required: true,
                    message: "组织名称不能为空",
                    trigger: "blur",
                }, ],
                code: [{
                    required: true,
                    message: "组织代码不能为空",
                    trigger: "blur",
                }, ],
                tenantName: [{
                    required: true,
                    message: "请先在页面顶部导航栏选择租户",
                    trigger: "blur",
                }, ],
            },
            plmTechCount: 0,
        };
    },
    components: {
        CommonUserDialog,
        TaskGetPart,
        FilesUpDown,
        AddOrUpdate,
        TaskRejectReason
    },
    mounted() {
        // this.getDataList();
    },
    methods: {
      getRowStyle({ row, rowIndex }) {
        if (row.cancelFlag === 1) {
          return { backgroundColor: '#f5f7fa' }; // 灰色背景
        }
        return {};
      },
        init(rec, viewFlag) {
            // this.dataForm = data ? data : this.dataForm
            this.userInfo = this.$store.state.user.userInfo;
            this.viewFlag = viewFlag;
            this.projectName = rec && rec.projectName || ''
            this.technicalType = rec && rec.technicalType || ''
            this.technicalName = rec && rec.technicalName || ''
            this.dataForm.id = rec && rec.id || null
            this.viewData.visible = true;
            this.dataForm.technicalId = rec.technicalId
            this.loading = false
            this.$nextTick(() => {
                this.$refs.FilesUpDown.init(this.viewFlag);
                //初始化上传附件
                this.$refs["dataForm"].resetFields();
                // this.dataForm.tenantName = sessionStorage.getItem('tenantName')
                if (this.dataForm && this.dataForm.id) {
                    getPurchaseTaskById({}, this.dataForm.id).then((data) => {
                        console.log(data);
                        if (data && data.code === "00") {
                            mapping(data.body, this.dataForm);
                            if(this.dataForm.rfqCode == null || this.dataForm.rfqCode == '') {
                                this.getPlmTechnicalCountByPT(this.dataForm.technicalCode)
                            }
                        }
                    });
                    this.getTaskApparmentList(this.dataForm.id);
                }
            });
        },
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD前");
        },
        dateFormatValue: function (value) {
            if (value == undefined) {
                return "";
            }
            return moment(value).format("YYYY-MM-DD前");
        },
        getTaskApparmentList() {
            getTaskApparmentList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                taskId: this.dataForm.id,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.partList = data.body.records;
                    this.totalPage = data.body.total;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                }
            });
        },
        // 表单提交
        dataSave() {
            let params = this.dataForm;
            if (params.taskStatus !== TASK_STATUS.DISTRIBUTED) {
                params.settingTaskStatus = TASK_STATUS.WAITING;
            }
            this.dataFormSubmit(params, "任务保存成功");
        },

        dataConfirm() {
            let params = this.dataForm;
            params.settingTaskStatus = TASK_STATUS.RECIEVED;
            this.dataFormSubmitSucc(params, "任务接受成功");
        },

        rejectConfirm() {
            let params = this.dataForm;
            params.settingTaskStatus = TASK_STATUS.WAITING;
            // 退回原因
            this.dataFormSubmitFal(params, "任务退回成功");
        },
        // 表单提交
        createRFQ() {
            let params = this.dataForm;
            params.settingTaskStatus = TASK_STATUS.RFQING;
            this.dataFormSubmitRfq(params, "创建询价单成功")
        },
        // 表单提交
        createOrder() {
            let params = this.dataForm;
            params.settingTaskStatus = TASK_STATUS.RECIEVEDORDER;
            this.dataFormSubmit(params, "创建订单成功");
        }, // 零件的分页方法
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getTaskApparmentList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getTaskApparmentList();
        },
        dataFormSubmitRfq(params, message) {
            this.loading = true
            setLoading()
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    if (this.dataForm.id) {
                        editPurchaseTaskRfq(params).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm = data.body
                                this.$message({
                                    message: message,
                                    type: "success",
                                    onClose: () => {
                                        this.viewData.visible = false;
                                        this.loading = false
                                        if (message === "创建询价单成功") {
                                            this.$router.push({
                                                path: '/sourcing-rfq'
                                            })
                                        } else {
                                            this.$emit("refreshDataList");
                                        }
                                    },
                                });

                            } else {
                                // this.$message.error(data.msg);
                            }
                        });
                    } else {
                        addPurchaseTask(params).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm = data.body;
                                this.$message({
                                    message: message,
                                    type: "success",
                                    onClose: () => {
                                        // this.viewData.visible = false;
                                        this.loading = false
                                        this.$emit("refreshDataList");
                                    },
                                });
                            } else {
                                // this.$message.error(data.msg);
                            }
                        });
                    }
                }
            });
        },
        dataFormSubmitSucc(params, message) {
            this.loading = true
            setLoading()
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    if (this.dataForm.id) {
                        editPurchaseTaskSucc(params).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm = data.body
                                location.reload()
                                this.$message({
                                    message: message,
                                    type: "success",
                                    onClose: () => {
                                        this.viewData.visible = false;
                                        this.loading = false
                                        if (message === "创建询价单成功") {
                                            this.$router.push({
                                                path: '/sourcing-rfq'
                                            })
                                        } else {
                                            this.$emit("refreshDataList");
                                        }
                                    },
                                });

                            } else {
                                // this.$message.error(data.msg);
                            }
                        });
                    } else {
                        addPurchaseTask(params).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm = data.body;
                                this.$message({
                                    message: message,
                                    type: "success",
                                    onClose: () => {
                                        // this.viewData.visible = false;
                                        this.loading = false
                                        this.$emit("refreshDataList");
                                    },
                                });
                            } else {
                                // this.$message.error(data.msg);
                            }
                        });
                    }
                }
            });
        },
        dataFormSubmitFal(params, message) {
            this.loading = true
            setLoading()
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    if (this.dataForm.id) {
                        editPurchaseTaskFal(params).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm = data.body
                                location.reload()
                                this.$message({
                                    message: message,
                                    type: "success",
                                    onClose: () => {
                                        this.viewData.visible = false;
                                        this.loading = false
                                        if (message === "创建询价单成功") {
                                            this.$router.push({
                                                path: '/sourcing-rfq'
                                            })
                                        } else {
                                            this.$emit("refreshDataList");
                                        }
                                    },
                                });

                            } else {
                                // this.$message.error(data.msg);
                            }
                        });
                    } else {
                        addPurchaseTask(params).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm = data.body;
                                this.$message({
                                    message: message,
                                    type: "success",
                                    onClose: () => {
                                        // this.viewData.visible = false;
                                        this.loading = false
                                        this.$emit("refreshDataList");
                                    },
                                });
                            } else {
                                // this.$message.error(data.msg);
                            }
                        });
                    }
                }
            });
        },
        dataFormSubmit(params, message) {
            this.loading = true
            setLoading()
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    if (this.dataForm.id) {
                        editPurchaseTask(params).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm = data.body
                                this.$message({
                                    message: message,
                                    type: "success",
                                    onClose: () => {
                                        this.viewData.visible = false;
                                        this.loading = false
                                        if (message === "创建询价单成功") {
                                            this.$router.push({
                                                path: '/sourcing-rfq'
                                            })
                                        } else {
                                            this.$emit("refreshDataList");
                                        }
                                    },
                                });

                            } else {
                                // this.$message.error(data.msg);
                            }
                        });
                    } else {
                        addPurchaseTask(params).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm = data.body;
                                this.$message({
                                    message: message,
                                    type: "success",
                                    onClose: () => {
                                        // this.viewData.visible = false;
                                        this.loading = false
                                        this.$emit("refreshDataList");
                                    },
                                });
                            } else {
                                // this.$message.error(data.msg);
                            }
                        });
                    }
                }
            });
        },
        // 选择定点申请
        selectTech() {
            const _this = this;
            this.$refs.addOrUpdateTech.open();
            this.$refs.addOrUpdateTech.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    mapping(payload.data, _this.dataForm, ["id"]);
                    console.log(
                        payload.data,
                        "payload.data",
                        this.dataForm.carType
                    );
                    _this.dataForm.technicalId = payload.data.defaultPositionId;
                }
            };
        },
        selectAppart() {
            // const _this = this;
            // this.partList 需要全部零件
            var taskId = this.dataForm.id;
            this.$refs.addOrUpdateAppart.open(
                this.dataForm.technicalId,
                taskId
            );
            this.$refs.addOrUpdateAppart.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    // payload.data === 'OK' 渲染零件列表
                    console.log("OK");
                    if (payload.data === "OK") {
                        this.getTaskApparmentList(taskId);
                    }
                }
            };
        },
        deleteAppart(id) {
            var taskId = this.dataForm.id;
            this.$confirm(`确定进行删除操作?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                deleteTaskApparmentByIds([id]).then((data) => {
                    if (data && data.code === "00") {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                this.getTaskApparmentList(taskId);
                            },
                        });
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            });
        },
        supplyStatusFormat: function (value) {
            if (!value) {
                return ''
            }
            return getLabelByValue(SUPPLY_STATUS, value)
        },
        getStyle() {
            return 'width: 130px; text-align: right'
        },
        getStyle2() {
            return 'width: 425.5px;'
        },
        techView() {
            this.addOrUpdateVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init({
                    id: this.dataForm.technicalId,
                    projectName: this.dataForm.projectName
                }, "view");
            });
        },
        rejectView() {
            this.$refs.taskRejectReason.open();
            this.$refs.taskRejectReason.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    console.log(payload.data)
                    debugger
                    this.dataForm.rejectReason = payload.data
                    this.dataForm.settingTaskStatus = TASK_STATUS.REJECT;
                    this.dataFormSubmitFal(this.dataForm, "任务退回成功")
                }
            };
        },
        //废弃按钮是否显示
        getPlmTechnicalCountByPT(technicCode) {
            getPlmTechnicalCountByPT({
                technicalCode: this.dataForm.technicalCode,
                technicalStatus: "2",
                receiveStatus: "1",
            }).then(data => {
                if (data && data.code === '00') {
                    if(data.body != null && data.body > 0)
                        this.plmTechCount = data.body
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        // 废弃
        deleteHandle(id, taskStatus) {
            this.$confirm(`是否废弃当前采购任务，注意此操作为不可逆操作，请确认?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deletePurchaseTaskFei({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.$emit("refreshDataList");
                                this.viewData.visible = false
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.tab_style {
    min-height: 35vh;
}
</style>
